<script>
  import Layout from '@layout/main'
  import ListFile from '@components/List/FileTable'
  import { BRAND } from '@src/config/fake-data'
  import setWindowHistory from "@utils/window-history";
  import { contractFileOptions } from "@utils/zerone-options";
  import { getDefaultContractFile } from "@utils/zerone-get-default";

  const DEFAULT_SEARCH = {
    fileCategory: '',
    month: '',
    query: ''
  };

  export default {
    page() {
      return {
        title: `共同供應契約採購`,
      }
    }, 
    components: {
      Layout,
      ListFile,
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
      pagination: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        search: '',
        optionsBrand: [
          {
            value: '',
            label: '所有品牌',
          },
          ...BRAND.map(item => {
            return {
              value: item.alias,
              label: item.text,
            }
          })
        ],
        searchData: {
          fileCategory: getDefaultContractFile(this.$route.query.fileCategory) || DEFAULT_SEARCH.fileCategory,
          month: this.$route.query.month || DEFAULT_SEARCH.month,
          query: this.$route.query.query || DEFAULT_SEARCH.query,
        },
        searchList: [
          {
            width: '20%',
            type: 'select',
            placeholder: '檔案類別',
            name: 'fileCategory',
            options: contractFileOptions(),
          },
          {
            width: '20%',
            type: 'month',
            placeholder: '不限時間',
            name: 'month',
          },
          {
            type: 'text',
            placeholder: '請輸入關鍵字',
            name: 'query',
          },
        ],
        fileList: this.list || [],
        filePagination: this.pagination || {},
        loadingFetchFileList: false,
        isShowFilterMenu: false
      }
    },
    computed: {
      hasFilter() {
        if(Object.keys(this.$route.query).length) {
          return Object.keys(this.$route.query)
            .some((key) => {
              return this.$route.query[key] !== undefined
            })
        } else {
          return false
        }
      },
    },
    created() {
      // this.fetchFilters()
    },
    methods: {
      // async fetchFilters() {
      //   const {contract_file_category} = await this.$store.dispatch("category/fetchCategroy", {types: ['contract_file_category']})
      //   this.searchList[0].options = contract_file_category.map(({alias, title})=>({text: title, value: alias}))
      // },
      onSubmit(data) {
        setWindowHistory({
          query: {
            // ...this.$route.query,
            page: 1
          }
        });
        this.tryToFetchFileList({

          storeParams: {
            // ...this.$route.params,
            page: 1
          }
        })
      },
      onChangePagination(page) {
        this.tryToFetchFileList({
          storeParams: {
            // ...this.$route.params,
            page
          }
        }).then(() => {
            const url = new URL(window.location)
            let params = url.searchParams;
            if(params.has('page')) {
              this.$scrollToElement({
                $el: this.$refs['sectionList'].$el,
                offset: 270,
              });
            }
        })
      },
      async tryToFetchFileList({ storeParams } = {}) {
        this.loadingFetchFileList = true;
        const params = {
          contentType: 'contract',
          search: this.searchData.query,
          categoryAlias: this.searchData.fileCategory,
          search_date: this.searchData.month,
          page: this.$route.query.page,
          limit: 10,
          orderBy: 'publish_up',
          ...storeParams
        }
        await this.$store.dispatch('global/searchFile', {
          ...params
        })
          .then(({ items, pagination }) => {
            this.fileList = items
            this.filePagination = pagination
          })
          .finally(() => {
            this.loadingFetchFileList = false;
          })
      },
      onClearSearch() {

        Object.keys(this.searchData)
          .forEach(key => {
            this.searchData[key] = undefined
          });

        setWindowHistory({
          query: {
            ...this.$route.query,
            ...this.searchData,
            page: 1
          }
        });
        this.tryToFetchFileList({
          storeParams: {
            page: 1
          }
        });
      },
      onOpenFilter(status) {
        this.isShowFilterMenu = status
      }
    },
  }
</script>
<template>
  <Layout>
    <BaseBanner 
      title="共同供應契約採購" 
      :image="require('@assets/images/bot/banner.png')"
      custom-class="isStyleWhite"
      @openFilter="onOpenFilter(!isShowFilterMenu)"
    />
    <section
      v-if="hasFilter || list.length"
      :class="$style.sectionFile"
      class="section "
    >
      <div class="container">
        <BaseSearchBar
          v-model="searchData"
          :list="searchList"
          submit-text="搜尋檔案"
          :is-show-filter="isShowFilterMenu"
          @search="onSubmit"
          @openFilter="onOpenFilter(false)"

        />
        <template v-if="fileList.length">
          <ListFile
            ref="sectionList"
            v-loading="loadingFetchFileList"
            :list="fileList"
            type="BOT"
          />
          <BasePagination2
            :pagination="filePagination"
            @change="onChangePagination"
          />
        </template>
        <BaseNull
          v-else
          is-search-null
          @clearSearch="onClearSearch"
        />
      </div>
    </section>
    <div v-else class="container section ">
      <BaseNull
        content="<p class='my-0'>目前此頁面尚無建置資料</p>"
      >
      </BaseNull>
    </div>
  </Layout>
</template>
<style lang="scss" module>
  .sectionFile {
    :global {
      .sectionFile {

      }
    }
  }
</style>
